<template>
<div class="container mb-4 p-sm-3 col-md-8">
  <h1>撮影会／イベント／教室 {{ titleText }}</h1>
  <p><span class="attention">※</span>必須</p>
  <form class="mb-5" method="post" @submit.prevent="confirm()">
    <div class="form-group p-3">
      <label for="PhotoParking">カテゴリ<span class="attention">※</span></label>
      <select class="form-control" id="PhotoParking" aria-required="true" v-model="event_kind">
        <option value="">選んで下さい...</option>
        <option value="photo">撮影会</option>
        <option value="event">イベント</option>
        <option value="school">教室</option>
      </select>
      <p class="error-msg" v-if="validation.event_kind">{{ validation.event_kind }}</p>
      <p>撮影会：講師主催のもの。規定料金以上。<br>イベント：企業、団体主催のもの。（体験会等）<br>教室：6回、3回コースの教室。</p>
    </div>
    <div :is="selectedForm" :validation="validation"></div>
    <div class="btn-group" role="group" aria-label="group">
      <a class="btn btn-secondary btn-lg" :class="preserveButtonStyle" formnovalidate @click="preserve()">下書き保存</a>
      <button type="submit" class="btn btn-primary btn-lg">入力内容確認</button>
    </div>
    <div class="attention text-left my-2">事務局承認後に掲載となります。(通常中3営業日)</div>
  </form>
  <p class="text-right mt-5">
    <router-link to="/mypage">マイページへのリンク</router-link>
  </p>
</div>
</template>

<script>
import eventInput from './input/EventInput'
import photoInput from './input/PhotoInput'
import schoolInput from './input/SchoolInput'
import binder from 'store/event_form/binder'
import util from 'util/lecturer'
import api from 'api'
export default {
  components: {
    'event_input': eventInput,
    'photo_input': photoInput,
    'school_input': schoolInput
  },
  beforeRouteEnter (to, from, next) {
    api.fetchNotReported()
    .then(notReported => {
      next(notReported ? '/lecturer/list' : true)
    }).catch(err => {
      if (err.status === 401) {
        next(vm => { api.onAuthRequired(vm) })
      } else {
        next(vm => { vm.$router.back(1) })
      }
    })
  },
  data () {
    return {
      validation: {},
      scrollAfterValidation: false
    }
  },
  methods: {
    confirm () {
      this.validation = util.validateForm(this)
      if (Object.keys(this.validation).length) {
        this.scrollAfterValidation = true
        return
      }

      this.$router.push({
        path: ['', this.event_kind, 'confirm'].join('/'),
        query: this.$route.query
      })
    },
    preserve () {
      this.validation = util.validateForm(this)
      if (Object.keys(this.validation).length) {
        this.scrollAfterValidation = true
        return
      }
      util.sendEvent(this, 'draft')
    }
  },
  computed: {
    ...binder,
    titleText () {
      return this.$route.query && this.$route.query.id
      ? '編集' : '新規作成'
    },
    selectedForm () {
      return (this.event_kind ? this.event_kind : 'event') + '_input'
    },
    preserveButtonStyle () {
      return ['', 'draft', 'notapproval'].some(st => st === this.status)
      ? '' : 'disabled'
    }
  },
  updated () {
    if (!this.scrollAfterValidation) {
      return
    }
    let el = this.$el.querySelector('p.error-msg')
    if (el) {
      let rect = el.getBoundingClientRect()
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop
      window.scrollTo(0, rect.top + scrollTop - 100) // XXX
    }
    this.scrollAfterValidation = false
  }
}
</script>



// WEBPACK FOOTER //
// InputRoot.vue?e5a6cf68